module.exports = __webpack_public_path__ + "img/bg_empty_city.f0ac2c91.jpg";